$(document).ready(function(){
  
  // BANNER
  $('.custom_bannner_head').slick({
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    arrow:false
  });

  // MAIN PRODUCT
  // setTimeout(function() {
  //   document.querySelector('.custom_varient-2').click();
  // },1500)
  
  // cart page progress bar slider
  $('.shipping_bar_products').slick({
    dots: true,
    infinite: true,
    dots:false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow:true,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><svg  class="Arrowleft arrow" width="10" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8301 20.1523L0.830078 10.6523L10.8301 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><svg  class="ArrowRight arrow" width="10" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17017 20.1523L11.1702 10.6523L1.17017 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  });  

  // CUSTOM DOWNLOAD ACCORDION  
  $(".custom_downlaod_accordion_head .accordion_title").on("click", function() {
    const DataTitle = $(this).attr("DataTitle");
      $(".custom_downlaod_accordion_sds_head").each(function(){
        const DataContent = $(this).attr("DataContent");
        if($(this).parents('.custom_downlaod_accordion').find('.downlaod_accordion_heading_icon').hasClass("downlaod_accordion_active")){
          $(this).parents('.custom_downlaod_accordion').find('.downlaod_accordion_heading_icon').removeClass("downlaod_accordion_active");
          $(this).slideUp()
        }
          else{
            if(DataTitle == DataContent){
              $(this).parents('.custom_downlaod_accordion').find('.downlaod_accordion_heading_icon').addClass("downlaod_accordion_active");
              $(this).slideToggle();
            }
            else{
              $(this).parents('.custom_downlaod_accordion').find('.downlaod_accordion_heading_icon').removeClass("downlaod_accordion_active");
              $(this).slideUp();
          }
        }
      });
  }); 

      $(".multi_accordion_heading").on("click", function() {
    const DataTitle = $(this).attr("DataTitle");
      $(".multi_accordion_content").each(function(){
        const DataContent = $(this).attr("DataContent");
         if($(this).parents('.multi_accordion_head').find('.multi_accordion_heading').hasClass("downlaod_accordion_active")){
            $(this).parents('.multi_accordion_head').find('.multi_accordion_heading').removeClass("downlaod_accordion_active");
            $(this).slideToggle();
          }
        else{
            if(DataTitle == DataContent){
              $(this).parents('.multi_accordion_head').find('.multi_accordion_heading').addClass("downlaod_accordion_active");
              $(this).slideToggle();
            }
            else{
              $(this).parents('.multi_accordion_head').find('.multi_accordion_heading').removeClass("downlaod_accordion_active");
              $(this).slideUp();
          }
        }
      });
  });

  // $('.downlaod_accordion_main_heading').click(function () {
  //   $(this).slideToggle();
  // });

 // TEXT WITH ACCORDION 
 $(".text_with_accordion_wrappper .text_with_accordion_heading").click(function(){
    var value_1 = $(this).attr("data-id");
   $(".text_with_accordion_text").each(function(){
    var value_2 = $(this).attr("data-class");
    if( $(this).parents(".text_with_accordion").find(".text_with_accordion_icon ").hasClass("accordion_active")){
      $(this).slideUp()
      $(this).parents(".text_with_accordion").find(".text_with_accordion_icon  ").removeClass("accordion_active")
    }else{
    if(value_1 == value_2){
      $(this).parents(".text_with_accordion").find(".text_with_accordion_icon ").addClass("accordion_active")
      $(this).slideToggle();
    }
      else{
        $(this).slideUp()
        $(this).parents(".text_with_accordion").find(".text_with_accordion_icon  ").removeClass("accordion_active")
      }
    }
   });
 });


   // PRODUCT GRID
  $('ul.custom_product_grid').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
     autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    arrow:false,
    prevArrow: '<button ><svg  class="Arrowleft arrow" width="10" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8301 20.1523L0.830078 10.6523L10.8301 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button ><svg  class="ArrowRight arrow" width="10" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17017 20.1523L11.1702 10.6523L1.17017 1.15234" stroke="#614141" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });

   
  // TESTIMONIAL
  $('.testimonial_block').slick({
    dots: true,
    infinite: false,
    speed: 300,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow:false,
 });
		AOS.init();

if($(window).width() < 1200){
$('.card_icon_content').slick({
    dots: true,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrow:false,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
 }
  
  // PRDOUCT SPECIFICATION TAB
$(".product-form__input input[type=radio]").on("click", function() {
   setTimeout(function() {
    var value_1 = $('.GD_main_varient').attr("value");
       $(".variant_product_specifications").each(function(){
        var value_2 = $(this).attr("varientid");
          if(value_1 == value_2){
            $(this).addClass("variant_active")
          }
          else{
            $(this).removeClass("variant_active")
          }
       });
    }, 500);
  }); 

    setTimeout(function() {
    var value_1 = $('.GD_main_varient').attr("value");
       $(".variant_product_specifications ").each(function(){
        var value_2 = $(this).attr("varientid");
          if(value_1 == value_2){
            $(this).addClass("variant_active")
          }
          else{
            $(this).removeClass("variant_active")
          }
       });
    }, 500);

  // LIQUID PRODUCT VARIENT TEXT 
  $('.product-form__input input[type=radio]').click(function(){
     setTimeout(function() {
      var value_X = $('.GD_main_varient').attr('value')
       $('.varinet_price_text').each(function() {
        var value_Y =  $(this).attr('varientid')
         if(value_X == value_Y){
          $(this).parents(".varinet_price_text_wrapper").find(".varinet_price_text ").addClass("active")
           console.log('yes')
         }
         else{
           $(this).parents(".varinet_price_text_wrapper").find(".varinet_price_text ").removeClass("active")
           console.log('no')
         }
       });
    }, 1000);
  }); 


// GC CALCULATOR
$(".gc_room_input").keyup(function () {
  var RoomWidth = $(this).parents('.gc_calculator_inputs_head').find('#gc-room-width').val();
  var RoomLength = $(this).parents('.gc_calculator_inputs_head').find('#gc-room-length').val();
  var RoomHeight = $(this).parents('.gc_calculator_inputs_head').find('#gc-room-height').val();
  var CanopyArea = $(this).parents('.gc_calculator_inputs_head').find('#canopy-area').val();
  var Canopy_Area = Number(CanopyArea);

  // Calculations
  let Width_Length = RoomWidth * RoomLength;
  let Height_Width = RoomHeight * RoomWidth;
  let Length_Height = RoomLength * RoomHeight;

  let Room_Volume = RoomWidth * RoomLength * RoomHeight;
  let Total_Wall_Area = 2 * (Width_Length + Height_Width + Length_Height);
  let Total_Spray_Area = Total_Wall_Area + Canopy_Area;
  let Total_Gallon_Nedded = Total_Wall_Area / 1000;

  // Liquid recommendations
  var Gallon_Added = Total_Gallon_Nedded;

  var Liquid_240_Varient = Math.floor(Gallon_Added / 240);
  Gallon_Added %= 30;

  var Liquid_30_Varient = Math.floor(Gallon_Added / 30);
  Gallon_Added %= 30;

  var Liquid_12_Varient = Math.floor(Gallon_Added / 12.5);
  Gallon_Added %= 12.5;

  var Liquid_2_Varient = Math.ceil(Gallon_Added / 2);

  $('.gc_recommendation_liquid').find('#Recommendation_Qty_Dispaly_1').text(Liquid_2_Varient);
  $('.gc_recommendation_liquid').find('#Recommendation_Qty_Dispaly_2').text(Liquid_12_Varient);
  $('.gc_recommendation_liquid').find('#Recommendation_Qty_Dispaly_3').text(Liquid_30_Varient);
  $('.gc_recommendation_liquid').find('#Recommendation_Qty_Dispaly_4').text(Liquid_240_Varient);

  $('.gc_recommendation_liquid').find('#Recommendation_Qty_selected_1').val(Liquid_2_Varient);
  $('.gc_recommendation_liquid').find('#Recommendation_Qty_selected_2').val(Liquid_12_Varient);
  $('.gc_recommendation_liquid').find('#Recommendation_Qty_selected_3').val(Liquid_30_Varient);
  $('.gc_recommendation_liquid').find('#Recommendation_Qty_selected_4').text(Liquid_240_Varient);

  // Solid recommendations
  var Solid_Added = Room_Volume;

  var Fast_Release_10K_Varient = Math.floor(Solid_Added / 10000);
  Solid_Added %= 10000;

  var Fast_Release_4K_Varient = Math.floor(Solid_Added / 4000);
  Solid_Added %= 4000;

  var Fast_Release_2_5K_Varient = Math.floor(Solid_Added / 2500);
  Solid_Added %= 2500;

  var Fast_Release_1K_Varient = Math.ceil(Solid_Added / 1000);

  $('.gc_recommendation_solid').find('#Recommendation_Qty_Dispaly_1').text(Fast_Release_1K_Varient);
  $('.gc_recommendation_solid').find('#Recommendation_Qty_Dispaly_2').text(Fast_Release_2_5K_Varient);
  $('.gc_recommendation_solid').find('#Recommendation_Qty_Dispaly_3').text(Fast_Release_4K_Varient);
  $('.gc_recommendation_solid').find('#Recommendation_Qty_Dispaly_4').text(Fast_Release_10K_Varient);

  $('.gc_recommendation_solid').find('#Recommendation_Qty_selected_1').val(Fast_Release_1K_Varient);
  $('.gc_recommendation_solid').find('#Recommendation_Qty_selected_2').val(Fast_Release_2_5K_Varient);
  $('.gc_recommendation_solid').find('#Recommendation_Qty_selected_3').val(Fast_Release_4K_Varient);
  $('.gc_recommendation_solid').find('#Recommendation_Qty_selected_4').val(Fast_Release_10K_Varient);

  // Update displayed values
  $(this).parents('.gc_calculator_wrapper').find('span.room_volume').text(Room_Volume);
  $(this).parents('.gc_calculator_wrapper').find('span.total_wall_area').text(Total_Wall_Area);
  $(this).parents('.gc_calculator_wrapper').find('span.canopy_area').text(Total_Spray_Area);
  $(this).parents('.gc_calculator_wrapper').find('span.total_gallon').text(Total_Gallon_Nedded);
});

// Trigger keyup initially to calculate values on load
$(".gc_room_input").trigger("keyup");


// VIDEO PAGE PLAY BUTTON  
$(".multicolumn_with_video_wrapper span.ytp-play-button").on("click", function() {
    const value_1 = $(this).attr("MultiVideoIcon");
       $(".multicolumn_with_video_media").each(function(){
        const value_2 = $(this).attr("MultiVideoMedia");
          if(value_1 == value_2){
            $(this).css("display", "none")
          }
          else{
             $(this).css("display", "flex")
          }
       });
});


// REGISTRATION PAGE PASSWORD
  toggleShowHideIconState();

  $('#RegisterForm-password').on('input', function () {
    toggleShowHideIconState();
  });

  $(".toggle-password").click(function() {
    var input = $($(this).attr("toggle"));
    togglePasswordVisibility(input);
  });

  function toggleShowHideIconState() {
    var passwordValue = $('#RegisterForm-password').val();
    $(".show_hide_icon").prop('disabled', passwordValue === '');
  }

  function togglePasswordVisibility(input) {
    var type = input.attr("type");
    input.attr("type", type === "password" ? "text" : "password");
    $(this).toggleClass("show-password");
  }
  
});

